import Message from '@talkdesk/cobalt-react-message'
import { Icon } from '@talkdesk/cobalt-react-icon'
import Flex from '@talkdesk/cobalt-react-flex'
import Box from '@talkdesk/cobalt-react-box'
import { Text, Heading } from '@talkdesk/cobalt-react-typography'

const ErrorMessage = props => {
  const { title, message } = props

  return (
    <Box paddingBottom={3}>
      <Message variation="error">
        <Flex direction="row" alignY="center" gap={2} padding={2}>
          <Icon name="error" size="small" />
          <Flex direction="column">
            {title ? <Heading level={5}>{title}</Heading> : null}
            {message ? <Text>{message}</Text> : null}
            {props.children ? <>{props.children}</> : null}
          </Flex>
        </Flex>
      </Message>
    </Box>
  )
}

export default ErrorMessage
